import * as types from "./types";

const setRequestInProcess = (requestType, inProcess) => ({
  type: types.SET_REQUEST,
  payload: { requestType, inProcess }
});

export { setRequestInProcess };
